<template>
  <div class="modal fade" id="edit-kios-modal">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down">
      <div class="modal-content border-0">
        <div class="modal-header border-0 pb-0">
           <div class="d-flex align-items-center gap-3">
              <button type="button" class="btn-close-mob d-md-none" data-bs-dismiss="modal">
                 <vue-feather type="x" size="20"></vue-feather>
              </button>
              <h5 class="fw-bold mb-0">Edit Kios SSP</h5>
           </div>
           <button type="button" class="btn-close d-none d-md-block" data-bs-dismiss="modal" ref="closeBtn"></button>
        </div>
        <div class="modal-body p-4">
           <form @submit.prevent="handleSave">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="mb-3">
                      <label class="form-label">Nama Toko / Kios</label>
                      <input type="text" v-model="form.nama_toko" class="form-control" placeholder="Masukkan nama toko" required />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="mb-3">
                      <label class="form-label">Nama Pemilik (Member)</label>
                      <input type="text" v-model="form.nama_member" class="form-control" placeholder="Masukkan nama pemilik" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="mb-3">
                      <label class="form-label">Kode Barcode</label>
                      <input type="text" v-model="form.kode_barcode" class="form-control" placeholder="Barcode" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="mb-3">
                      <label class="form-label">Petugas Pendamping</label>
                      <vue-select
                        :options="pendampingOptions"
                        v-model="form.pendamping_id"
                        id="edit-kios-pendamping"
                        placeholder="Pilih Petugas"
                      />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="mb-3">
                      <label class="form-label">Alamat Lengkap</label>
                      <textarea v-model="form.alamat" class="form-control" rows="3" placeholder="Masukkan alamat"></textarea>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="mb-3">
                      <label class="form-label">Status</label>
                      <vue-select
                        :options="statusOptions"
                        v-model="form.status"
                        id="edit-kios-status"
                        placeholder="Pilih Status"
                      />
                    </div>
                  </div>
                </div>
                <div class="d-grid mt-4">
                   <button type="submit" class="btn btn-dark rounded-pill py-3 fw-bold shadow-sm" :disabled="loading">
                      {{ loading ? 'MENYIMPAN...' : 'SIMPAN PERUBAHAN' }}
                   </button>
                </div>
              </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-close-mob {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.form-label {
    font-size: 11px;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.form-control {
    border: 1px solid #f1f5f9;
    background: #f8fafc;
    border-radius: 12px;
    padding: 12px 15px;
    font-size: 14px;
}
.form-control:focus {
    border-color: #029147;
    background: white;
    box-shadow: none;
}
</style>

<script>
import { reactive, watch, ref, computed } from 'vue';
import memberService from '@/services/memberService';
import { useDataStore } from '@/store/dataStore';
import Swal from 'sweetalert2';

export default {
  props: {
    member: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { pendampings, refreshData } = useDataStore();
    const loading = ref(false);
    const closeBtn = ref(null);
    
    const form = reactive({
      nama_toko: '',
      nama_member: '',
      kode_barcode: '',
      pendamping_id: null,
      alamat: '',
      status: 'active'
    });

    const statusOptions = [
      { id: 'active', text: 'Aktif' },
      { id: 'inactive', text: 'Non-Aktif' }
    ];

    const pendampingOptions = computed(() => {
      return pendampings.value.map(p => ({
        id: p.id,
        text: p.nama_pendamping
      }));
    });

    watch(() => props.member, (newVal) => {
      if (newVal && newVal.id) {
        form.nama_toko = newVal.nama_toko || '';
        form.nama_member = newVal.nama_member || '';
        form.kode_barcode = newVal.kode_barcode || '';
        form.pendamping_id = newVal.pendamping_id || null;
        form.alamat = newVal.alamat || '';
        form.status = newVal.status || 'active';
      }
    }, { immediate: true });

    const handleSave = async () => {
      if (!props.member.id) return;
      
      loading.value = true;
      try {
        await memberService.updateMember(props.member.id, { ...form });

        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        Toast.fire({
          icon: 'success',
          title: 'Kios berhasil diperbarui'
        });

        await refreshData('members');
        
        if (closeBtn.value) {
          closeBtn.value.click();
        }
      } catch (error) {
        console.error("Update error:", error);
        Swal.fire({
          icon: 'error',
          title: 'Gagal memperbarui kios'
        });
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      statusOptions,
      pendampingOptions,
      loading,
      handleSave,
      closeBtn
    };
  }
};
</script>
